import { __await } from 'tslib';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, OnDestroy, Output, EventEmitter, Input, SimpleChanges, OnChanges, Inject, Optional, Renderer2, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';

import { environment } from 'src/environments/environment';

import { ReviewType } from 'src/app/model/enums/reviewType';
import { ReviewInterface } from 'src/app/model/reviews/review-interface';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';

import { UserService } from 'src/app/services/user-service/userservice';
import { ReviewService } from 'src/app/services/review-service/review.service';
import { PtgService } from 'src/app/services/dataServices/ptg-service/ptgService';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { ProductlistService } from 'src/app/services/productlist-service/productlist.service';
import { NavbarService } from 'src/app/services/componentServices/navbar-service/navbar-service';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { TrackingService } from 'src/app/services/tracking-service/tracking.service';
import { Title, Meta } from '@angular/platform-browser';
import { MarketplaceFilterService } from 'src/app/services/componentServices/marketplace-filter-service/marketplace-filter.service';
import { MatSelectChange } from '@angular/material/select';
import { CertificationVariantInterface } from 'src/app/model/certifications/certification-variant-interface';
import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { ProductCategory } from 'src/app/model/enums/productCategory';
import { PLATFORM_ID } from '@angular/core';


@Component({
  selector: 'app-product-detail-display-full',
  templateUrl: './product-detail-display-full.component.html',
  styleUrls: ['./product-detail-display-full.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ProductDetailDisplayFullComponent implements OnInit, OnChanges, OnDestroy {

  @Output() goBack = new EventEmitter<void>();
  @Output() reloadDisplayItems = new EventEmitter<number>();
  @Output()
  onVariantChosen: EventEmitter<ProductVariantInterface | CertificationVariantInterface>;
  @Input() actualProduct: ProductInterface;
  bookmarked = false;
  isBookmarkedChanged = false;
  hasDocuments = false;
  hasCertificate = false;
  reviews: ReviewInterface[] = [];
  average: number;
  selectedTab = 0;
  displayedColumns: string[] = ['merkmal', 'value'];
  showWriteReview: boolean = false;
  certificationTooltip = 'Zertifikat für BIMSWARM Partnership';
  certificationCountTooltip = 'BIMSWARM Partner';
  certificationImageUrl = environment.partnerCert;
  variant: any;
  private ptgNames: string[];
  private nrOfReviews: number[] = [0, 0, 0, 0, 0];
  private product: ProductInterface;
  private paramSubscription: Subscription;
  selectedVariant: VariantVersionInterface | null = null;
  latestVersions: { variant: ProductVariantInterface, version: VariantVersionInterface }[] = [];
  public reviewType: ReviewType;
  public keywords: string[] = []; // obsolete?
  public pictureUrl: string;
  public displaySpinner = true;
  public organisation: OrganisationInterface;
  disabledFeatures: boolean = false;
  enterprise: boolean = false;
  private delaySubscription: Subscription | undefined
  @ViewChildren('tabContent') tabContents!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChild('rating') ratingPane!: ElementRef;
  commonFeatures: ProductCommonFeatureInterface[];
  combinedDescription = '';
  private readonly canonicalSelector = 'link[rel="canonical"]';
  private managesCanonicalTag = false;

  get isFullPage(): boolean {
    return this.data === undefined;
  }

  constructor(
    @Optional() public dialogRef: MatDialogRef<ProductDetailDisplayFullComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private productListService: ProductlistService,
    private dialogService: DialogService,
    private navbarService: NavbarService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private reviewService: ReviewService,
    private userService: UserService,
    private productService: ProductService,
    private readonly ptgService: PtgService,
    private readonly organisationService: OrganisationService,
    private readonly route: ActivatedRoute,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private trackingService: TrackingService,
    private titleService: Title,
    private meta: Meta,
    private marketplaceFilter: MarketplaceFilterService,
    private viewportScroller: ViewportScroller,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object

  ) {
    this.reviewType = ReviewType.PRODUCT_REVIEW;
    this.onVariantChosen = new EventEmitter();
  }

  ngOnInit() {
    if (this.data) {
      this.actualProduct = this.data.product;
      if (!this.data.preview) {
        this.productService.reload(this.actualProduct.id).then((success) => {
          this.actualProduct = success;
          this.delaySubscription = this.trackingService.delayedAction().subscribe(() => {
            this.titleService.setTitle(this.actualProduct.name);
            this.meta.updateTag({ name: 'description', content: this.actualProduct.description })
            this.meta.updateTag({ name: 'url', content: this.actualProduct.url });
            this.trackingService.trackEvents('OrganisationView' + this.actualProduct.company);
            this.trackingService.trackEvents('ProductView');
            this.trackingService.trackPageView('');
            this.trackingService.trackEventsWithProps('ProductView' + this.actualProduct.id, {
              isLoggedIn: this.userService.loggedIn ? "Eingeloggt" : "Nicht Eingeloggt",
              email: this.userService.currentUser.userName,
              filter: this.marketplaceFilter.commonFeatureEntriesFilter.toString(),
              searchText: this.marketplaceFilter.searchText.toString()
            });
          });
          this.getProductDetails();
          this.cd.detectChanges();
          this.loadReviews();
          this.bookmarked = this.isBookmarked(this.actualProduct.id, 1);
          this.renderer.addClass(this.elRef.nativeElement, 'in-dialog');
          if (this.actualProduct.listingPkgName == 'Free (Basic)' || !this.actualProduct.listingPkgName) {
            this.disabledFeatures = true;
          } else if (this.actualProduct.listingPkgName == 'Enterprise') {
            this.enterprise = true;
          }
          this.cd.detectChanges();
        })
      } else {
        this.commonFeatures = this.data.commonFeatures;
        this.actualProduct = this.data.product;
        this.hasProductDocuments();
        this.collectKeywordsFromAllActiveVersions();
        this.getOrganisationName();
        this.setProductPicture();
        this.prepareCombinedDescription();
        this.cd.detectChanges();
        this.renderer.addClass(this.elRef.nativeElement, 'in-dialog');
        this.enterprise = true;
        this.cd.detectChanges();
      }
    } else {
      const resolvedProduct = this.route.snapshot.data[
        'marketplaceProduct'
      ] as ProductInterface | undefined;

      if (resolvedProduct) {
        this.initialiseProduct(resolvedProduct);
      }

      this.route.paramMap.subscribe((params: ParamMap) => {
        const id = params.get('productId');
        if (id && (!resolvedProduct || resolvedProduct.id !== +id)) {
          this.productService.reload(+id).then((product) => {
            this.initialiseProduct(product);
          });
        }
      });
    }
  }

  get totalCertificateCount(): number {
    if (!this.actualProduct) return 0;
    return (
      (this.actualProduct.attributeCertificationCount || 0) +
      (this.actualProduct.ptgCertificationCount || 0) +
      (this.actualProduct.toolchainCertificationCount || 0)
    );
  }

  ngOnChanges(product: SimpleChanges) {
    if (product != null) {
      this.actualProduct = product.actualProduct.currentValue;
      if (this.delaySubscription) {
        this.delaySubscription.unsubscribe();
      }
      this.titleService.setTitle(this.actualProduct.name);
      this.meta.updateTag({ name: 'description', content: this.actualProduct.description })
      this.meta.updateTag({ name: 'url', content: this.actualProduct.url });
      this.trackingService.cancelDelay();
      this.trackingService.trackEvents('OrganisationView' + this.actualProduct.company);
      this.trackingService.trackEvents('ProductView');
      this.trackingService.trackPageView('');
      this.trackingService.trackEventsWithProps('ProductView' + this.actualProduct.id, {
        isLoggedIn: this.userService.loggedIn ? "Eingeloggt" : "Nicht Eingeloggt",
        email: this.userService.currentUser.userName,
        filter: this.marketplaceFilter.commonFeatureEntriesFilter.toString(),
        searchText: this.marketplaceFilter.searchText.toString()
      });
      this.getProductDetails();
      if (this.actualProduct) {
        this.loadReviews();
        this.titleService.setTitle(this.actualProduct.name);
        this.meta.updateTag({ name: 'description', content: this.actualProduct.description })
        this.meta.updateTag({ name: 'url', content: this.actualProduct.url });
        this.delaySubscription = this.trackingService.delayedAction().subscribe(() => {
          this.trackingService.trackEvents('OrganisationView' + this.actualProduct.company);
          this.trackingService.trackEvents('ProductView');
          this.trackingService.trackPageView('');
          this.trackingService.trackEventsWithProps('ProductView' + this.actualProduct.id, {
            isLoggedIn: this.userService.loggedIn ? "Eingeloggt" : "Nicht Eingeloggt",
            email: this.userService.currentUser.userName,
            filter: this.marketplaceFilter.commonFeatureEntriesFilter.toString(),
            searchText: this.marketplaceFilter.searchText.toString()
          });
        })
        this.bookmarked = this.isBookmarked(this.actualProduct.id, 1);
      }
      if (this.actualProduct.listingPkgName == 'Free (Basic)' || !this.actualProduct.listingPkgName) {
        this.disabledFeatures = true;
      }
      else if (this.actualProduct.listingPkgName == 'Enterprise') {
        this.enterprise = true;
      }
    }
    this.cd.detectChanges();
  }

  get fileIds() {
    return this.product.documentFileIds;
  }

  getProductDetails() {
    this.hasProductDocuments();
    this.hasProductCertification();
    this.collectKeywordsFromAllActiveVersions();
    this.setReviewType();
    this.getOrganisationName();
    this.setProductPicture();
    this.getLatestActiveVariantVersions();
    this.prepareCombinedDescription();
  }

  private initialiseProduct(product: ProductInterface) {
    this.actualProduct = product;
    this.syncSeoMeta();
    this.trackProductView();
    this.getProductDetails();
    this.loadReviews();
    this.bookmarked = this.isBookmarked(this.actualProduct.id, 1);
    this.disabledFeatures =
      this.actualProduct.listingPkgName == 'Free (Basic)' ||
      !this.actualProduct.listingPkgName;
    this.enterprise = this.actualProduct.listingPkgName == 'Enterprise';
    this.cd.detectChanges();
  }

  private syncSeoMeta() {
    if (!this.actualProduct) {
      return;
    }

    const marketplaceProductUrl = this.getMarketplaceProductUrl();

    this.titleService.setTitle(this.actualProduct.name);
    this.meta.updateTag({
      name: 'description',
      content: this.actualProduct.description || ''
    });
    this.meta.updateTag({
      property: 'og:title',
      content: this.actualProduct.name || ''
    });
    this.meta.updateTag({
      property: 'og:description',
      content: this.actualProduct.description || ''
    });
    this.meta.updateTag({
      property: 'og:url',
      content: marketplaceProductUrl
    });
    this.meta.updateTag({
      name: 'url',
      content: marketplaceProductUrl
    });
    this.syncCanonicalTag(marketplaceProductUrl);
  }

  private trackProductView() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (this.delaySubscription) {
      this.delaySubscription.unsubscribe();
    }

    this.delaySubscription = this.trackingService.delayedAction().subscribe(() => {
      this.trackingService.trackEvents('OrganisationView' + this.actualProduct.company);
      this.trackingService.trackEvents('ProductView');
      this.trackingService.trackPageView('');
      this.trackingService.trackEventsWithProps('ProductView' + this.actualProduct.id, {
        isLoggedIn: this.userService.loggedIn ? "Eingeloggt" : "Nicht Eingeloggt",
        email: this.userService.currentUser.userName,
        filter: this.marketplaceFilter.commonFeatureEntriesFilter.toString(),
        searchText: this.marketplaceFilter.searchText.toString()
      });
    });
  }

  private getMarketplaceProductUrl() {
    const origin = this.document.location?.origin ?? '';
    const path = `/marktplatz/products/${this.actualProduct?.id ?? ''}`;
    return `${origin}${path}`;
  }

  private syncCanonicalTag(url: string) {
    if (!this.document?.head || !url) {
      return;
    }

    let canonicalLink = this.document.head.querySelector<HTMLLinkElement>(this.canonicalSelector);

    if (!canonicalLink) {
      canonicalLink = this.renderer.createElement('link');
      this.renderer.setAttribute(canonicalLink, 'rel', 'canonical');
      this.renderer.appendChild(this.document.head, canonicalLink);
    }

    this.renderer.setAttribute(canonicalLink, 'href', url);
    this.managesCanonicalTag = true;
  }

  private removeCanonicalTag() {
    if (!this.managesCanonicalTag) {
      return;
    }

    const canonicalLink = this.document?.head?.querySelector<HTMLLinkElement>(this.canonicalSelector);

    if (!canonicalLink) {
      return;
    }

    this.renderer.removeChild(this.document.head, canonicalLink);
    this.managesCanonicalTag = false;
  }

  selectTab(tabIndex: number) {
    this.selectedTab = tabIndex;
  }

  onTabChange(event: any) {
    const parent = document.querySelector('.mat-dialog-container'); // Replace with your parent selector
    const x = parent ? parent.scrollLeft : window.scrollX;
    const y = parent ? parent.scrollTop : window.scrollY;

    setTimeout(() => {
      if (parent) {
        parent.scrollTo(x, y);
      } else {
        window.scrollTo(x, y);
      }
    }, 0);

    if (event.index !== 4) {
      this.showWriteReview = false;
    }
  }

  isLoggedIn(): boolean {
    return this.userService.loggedIn;
  }

  toggleProductInList(productId: number) {
    if (this.bookmarked) {
      this.removeProductFromList(productId, 1);
    } else {
      this.addToProductList(productId, 1);
    }
  }

  setProductPicture() {
    if (this.actualProduct === null) {
      this.pictureUrl = environment.defaultPictureOrganisationProducts;
    } else {
      this.pictureUrl = this.productService.getProductPicture(this.actualProduct?.id);
      this.displaySpinner = false;
      this.cd.detectChanges();
    }
  }

  private setReviewType() {
    if (this.actualProduct != null) {
      this.displaySpinner = true;
      this.actualProduct.reviewType = ReviewType.PRODUCT_REVIEW;
      this.displaySpinner = false;
    }
  }

  isBookmarked(productId: number, displayType: number) {
    let isBookmarked = false;
    this.productListService
      .getProductList()
      .getValue()
      .forEach((bookmarkedProduct) => {
        if (
          bookmarkedProduct.id == productId &&
          bookmarkedProduct.displayType === displayType
        ) {
          isBookmarked = true;
        }
      });
    return isBookmarked;
  }

  hasProductDocuments() {
    if (this.actualProduct?.documentFileIds != null) {
      this.displaySpinner = true;
      if (this.actualProduct.documentFileIds.length > 0) { this.hasDocuments = true; }
      this.displaySpinner = false;
      this.cd.detectChanges();
    }
  }

  hasProductCertification() {
    if (this.actualProduct?.productVariants != null) {
      this.displaySpinner = true;
      const versions = this.actualProduct.productVariants
        .map((p) => p.variantVersions)
        .reduce((va1, va2) => va1.concat(va2));
      this.hasCertificate = versions.some(
        (v: VariantVersionInterface) => {
          return (
            v.certificationVariantVersions &&
            v.certificationVariantVersions.length > 0
          );
        }
      );
      this.displaySpinner = false;
      this.cd.detectChanges();
    }
  }

  collectKeywordsFromAllActiveVersions() {
    if (this.actualProduct?.productVariants != null) {
      this.displaySpinner = true;
      const variants: VariantVersionInterface[] =
        this.actualProduct.productVariants
          .map((x: ProductVariantInterface) => x.variantVersions)
          .reduce(
            (
              x: VariantVersionInterface[],
              y: VariantVersionInterface[]
            ) => x.concat(y)
          )
          .filter(
            (x: VariantVersionInterface) => x.status === 'ACTIVE'
          );
      this.keywords = Array.from(
        new Set(
          variants
            .map((x) => x.keywords)
            .reduce((x, y) => x.concat(y))
            .sort()
        )
      );
      this.displaySpinner = false;
      this.cd.detectChanges();
    }
  }

  getLatestActiveVariantVersions(): VariantVersionInterface[] {
    if (!this.actualProduct?.productVariants) {
      return [];
    }
    const allVariants = this.actualProduct.productVariants;
    const allVersionsWithParent: { variant: ProductVariantInterface, version: VariantVersionInterface }[] = [];
    for (const variant of allVariants) {
      if (variant.variantVersions) {
        for (const version of variant.variantVersions) {
          allVersionsWithParent.push({ variant, version });
        }
      }
    }
    const grouped = new Map<string, any[]>();
    for (const vwp of allVersionsWithParent) {
      const key = vwp.variant.name;
      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key)!.push(vwp);
    }
    this.latestVersions = Array.from(grouped.values()).map(group => {
      const activeVersions = group.filter(v => v.version.status === 'ACTIVE');
      let latest;
      if (activeVersions.length > 0) {
        latest = activeVersions.reduce((a, b) =>
          (a.version.previousVersion > b.version.previousVersion ? a : b)
        );
      } else {
        latest = group.reduce((a, b) =>
          (a.version.previousVersion > b.version.previousVersion ? a : b)
        );
      }
      return latest;
    }).sort((a, b) => b.variant.id - a.variant.id);
    this.selectedVariant = this.latestVersions.length > 0 ? this.latestVersions[0].variant : null;
  }


  getOrganisationName() {
    if (this.actualProduct?.company != null) {
      this.displaySpinner = true;
      this.organisationService
        .reload(this.actualProduct.company)
        .then(
          (organisation) => {
            this.organisation = organisation;
            this.cd.detectChanges();
            this.displaySpinner = false;
          },
          (e) => {
            this.displaySpinner = false;
          }
        );
    }
  }


  productCategory() {
    switch (this.actualProduct.category) {
      case 1: { return 'Software'; }
      case 2: { return 'Datenbanken'; }
      case 3: { return 'Fachpublikationen'; }
    }
    return '';
  }

  navigateToMarketplaceWithCategory() {
    switch (this.actualProduct.category) {
      case 1: { this.marketplaceFilter.setChangeProductCategoryFilter(ProductCategory.Software); break; }
      case 2: { this.marketplaceFilter.setChangeProductCategoryFilter(ProductCategory.database); break; }
      case 3: { this.marketplaceFilter.setChangeProductCategoryFilter(ProductCategory.SpecPub); break; }
    }
    this.router.navigate(['/marktplatz'], {
      queryParams: {
        tab: 0,
        category: this.productCategory()
      }
    });
  }

  navigateToMarketplace() {
    switch (this.actualProduct.category) {
      case 1: { this.marketplaceFilter.setChangeProductCategoryFilter(ProductCategory.Software); break; }
      case 2: { this.marketplaceFilter.setChangeProductCategoryFilter(ProductCategory.database); break; }
      case 3: { this.marketplaceFilter.setChangeProductCategoryFilter(ProductCategory.SpecPub); break; }
    }
    this.router.navigate(['/marktplatz'], {
      queryParams: {
        tab: 0
      }
    });
  }

  getAllPtgNames() {
    if (this.actualProduct?.productVariants != null) {
      this.displaySpinner = true;

      const allVariantVersions = this.actualProduct.productVariants
        .map(x => x.variantVersions ?? [])
        .reduce((a, b) => a.concat(b), []);
      const allPtgVersions = allVariantVersions
        .map(x => x?.ptgVersions ?? [])
        .reduce((a, b) => a.concat(b), []);
      this.ptgNames = Array.from(
        new Set(
          allPtgVersions
            .map(ptgVersion => this.ptgService.getPtgFromVersion(ptgVersion)?.name)
            .filter(name => name != null)
            .sort()
        )
      );
      this.displaySpinner = false;
      this.cd.detectChanges();
    }
  }

  public onReviewsChanged(reviewOverview: { avg: number; count: number; }): void {
    if (this.product !== undefined) {
      this.product.rating = reviewOverview.avg;
      this.product.ratingCount = reviewOverview.count;
    }
  }

  addToProductList(productId: number, displayType: number): void {
    this.productListService
      .addElementToList(productId, 1)
      .subscribe(() => {
        this.dialogService.openDialog('Das Produkt wurde zu Ihrer Merkliste hinzugefügt', '');
        if (!this.navbarService.NAV_STATE_MY_PRODUCTS_LIST) {
          this.navbarService.NAV_STATE_MY_PRODUCTS_LIST = true;
          this.navbarService.loadButtons();
        }
      });
  }

  removeProductFromList(productId: number, displayType: number): void {
    this.productListService
      .deleteElementFromList(productId, 1)
      .subscribe(() => {
        this.dialogService.openDialog('Das Produkt wurde von Ihrer Merkliste entfernt', '');
      });
  }

  bookmark(event: Event) {
    event.stopPropagation();
    this.bookmarked = !this.bookmarked;
    this.isBookmarkedChanged = true;
  }

  routeToWebsite() {
    if (this.actualProduct.url == null || this.actualProduct.url == '') { return; }
    let url;
    if (this.actualProduct.url.match('http')) { url = this.actualProduct.url; }
    else { url = 'http://' + this.actualProduct.url; }
    let valid_url;
    try { valid_url = new URL(url); }
    catch (e) { return; }
    window.open(url, '_blank');
  }

  requestDemo() {
    this.dialogService.openDemoRequestDialog(this.actualProduct.id);
  }

  openInNewTab(id: any) {
    window.open('/marktplatz/products/' + this.actualProduct.id, '_blank');
  }

  goToMarketPlatz() {
    this.router.navigateByUrl('/marktplatz')
  }

  navigateToProduct(id: number) {
    const queryParams: Params = {
      tab: 0,
      productId: id,
      ptgId: null,
      ptgAttrId: null,
      certificationId: null,
      orgId: null,
      organisationId: null,
      attr: null,
      category: null,
      certificationType: null,
      rating: null,
      flag: null
    };
    this.displaySpinner = true;
    this.cancel();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
    this.cd.detectChanges();
  }

  navigateToOrganisation(id: number) {
    const queryParams: Params = {
      tab: 2,
      productId: null,
      ptgId: null,
      ptgAttrId: null,
      certificationId: null,
      orgId: id,
      organisationId: id,
      attr: null,
      category: null,
      certificationType: null,
      rating: null,
      flag: null
    };
    this.displaySpinner = true;
    this.cancel();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
    this.cd.detectChanges();
  }

  requestOffer() {
    this.dialogService.openOfferRequestDialog(this.actualProduct.id);
  }

  async loadReviewsAsync() {
    this.reviews = await this.reviewService.getReviews(
      this.reviewType,
      this.actualProduct?.id
    );
  }

  loadReviews() {
    this.loadReviewsAsync().then(() => {
      this.loadReviewStatistic();
      this.loadAverageScore();
      this.reloadDisplayItems.emit(this.actualProduct.id);
    });
  }

  loadAverageScore() {
    let stars = 0;
    let amount = this.reviews.length;
    this.reviews.forEach((review) => { stars += review.stars; });
    if (amount != 0) { this.average = stars / amount; }
    else { this.average = 0; }
    this.onReviewsChanged({
      avg: this.average,
      count: this.reviews.length
    });
    this.cd.detectChanges();
  }

  loadReviewStatistic() {
    this.nrOfReviews = [0, 0, 0, 0, 0];
    this.reviews.forEach((review) => { this.nrOfReviews[review.stars - 1]++; });
    this.cd.detectChanges();
  }


  hasUserReviewedProduct(): boolean {
    return this.reviews.some((review: ReviewInterface) => review.creatorId === this.userService.currentUser.userId);
  }

  goToRatingPane(action: string) {
    if (!this.disabledFeatures) {
      this.selectTab(4);
      if (this.ratingPane?.nativeElement) {
        if (action === 'show') {
          setTimeout(() => { this.ratingPane.nativeElement.scrollIntoView({ behavior: 'smooth' }); }, 250);
        } else if (action === 'review') {
          this.goToBottom(this.ratingPane.nativeElement);
        }
      }
    }
  }

  goToBottom(el: HTMLElement) {
    if (this.userService.loggedIn) {
      this.showWriteReview = true;
      setTimeout(() => { el.scrollIntoView({ behavior: 'smooth' }); }, 250);
    } else {
      this.dialogService.openLoginDialog().subscribe((result) => {
        if (result === 'error') {
          this.dialogService.openDialog('Ein Fehler ist aufgetreten.', 'Bitte versuchen Sie es später erneut.');
        }
      });
    }
  }

  ngOnDestroy() {

    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe();
    }
    if (this.delaySubscription) {
      this.delaySubscription.unsubscribe();
    }
    this.titleService.setTitle('Marktplatz - - Construct-X');
    this.removeCanonicalTag();
    this.trackingService.cancelDelay();
    this.trackingService.trackEvents('OrganisationView' + this.actualProduct.company);
    this.trackingService.trackEvents('ProductView');
    this.trackingService.trackPageView('');
    this.trackingService.trackEventsWithProps('ProductView' + this.actualProduct.id, {
      isLoggedIn: this.userService.loggedIn ? "Eingeloggt" : "Nicht Eingeloggt",
      email: this.userService.currentUser.userName,
      filter: this.marketplaceFilter.commonFeatureEntriesFilter.toString(),
      searchText: this.marketplaceFilter.searchText.toString()
    });
  }

  cancel(): void {
    const result = { isBookmarkedChanged: this.isBookmarkedChanged };
    this.dialogRef.close(result);
  }

  onNavigationTriggered() {
    if (this.dialogRef) {
      const result = { isBookmarkedChanged: this.isBookmarkedChanged };
      this.dialogRef.close(result);
    }
  }

  onVariantChange(event: MatSelectChange) {
    this.variant = event;
    this.onVariantChosen.emit(
      event.value as ProductVariantInterface
    );
    this.prepareCombinedDescription();
  }

  prepareCombinedDescription() {
    if (!this.actualProduct) return;

    const productDesc = this.actualProduct.description || '';
    const variantDesc = this.selectedVariant?.description || '';

    this.combinedDescription = productDesc + (variantDesc ? `<span>Variante - ${this.selectedVariant.name}</span>` + variantDesc : '');
    // this.combinedDescription = productDesc + (variantDesc ? variantDesc : '');
  }

  getReviewTooltip(): string | null {
    if (this.actualProduct.id == null || this.disabledFeatures) {
      return 'Für dieses Produkt sind keine Bewertungen verfügbar.';
    }

    if (!this.userService.loggedIn) {
      return 'Melden Sie sich bitte an, um eine Bewertung zu schreiben.';
    }

    return null;
  }


  openBautageBuch() {
    window.open('https://cx.planen-bauen40.de/bautagebuch', '_blank');
  }

  openSharePoint() {
    window.open('https://cx.planen-bauen40.de/sharepoint', '_blank');
  }
}
